import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import {PermissionService} from "~/pages/back-office/roles/services/permission.service";

@Injectable({
  providedIn: 'root',
})
export class AuthorizationGuard  {
  constructor(
    private auth: AuthenticationService,
    private router: Router,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const isLoggedIn = this.auth.isLoggedIn();
    if (isLoggedIn) {
      const routeRoles = next.data.roles;
      const routeExtras = next.data.extras;
      const routeAditional = next.data.aditional;
      const extraPermission = next.data.extraPermission;
      const rolePermissions = next.data.rolePermissions;
      let hasPermission = this.auth.hasPermission(routeRoles);

      if (rolePermissions && PermissionService.check(rolePermissions)) {
        return true;
      }

      if (routeExtras) {
        hasPermission = hasPermission || this.auth.hasExtraPermissions(routeExtras.profiles, routeExtras.permissions);
      }

      if (routeAditional) {
        hasPermission = hasPermission || this.auth.hasAditionalPermissions(routeAditional.profiles, routeAditional.permissions);
      }

      if (extraPermission && extraPermission.profiles === this.auth.getCurrentUser().type) {
        hasPermission = hasPermission && this.auth.hasExtraAditionalPermissions(extraPermission.profiles, extraPermission.permissions);
      }

      if (!hasPermission) {
        return this.router.navigate(['/']);
      }

      return hasPermission;
    }

    return isLoggedIn;
  }
}
